// External libs
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

// decode the tenant id for the display config 
import { jwtDecode } from "jwt-decode";

// backend service
import { loadTenantConfig } from "../services/tenantService.js";

// widget components
import WidgetRenderer from "../components/WidgetRenderer.js";
import WidgetDeviceSummary from "../components/widgets/WidgetDeviceSummary.js";
import DeviceControlPanel from "../components/DeviceControlPanel.js"

import { useDevice } from "../hook/userDevice.js"

/**
 * The device detials page to be display for one specific device. 
 *
 * @returns {JSX.Element} The rendered device details page
 * 
 */
const DeviceDetailsPage = () => {
  const { deviceId } = useParams();
  const { data: device, isLoading, error } = useDevice(deviceId);

  const [config, setConfig] = useState(null);

  useEffect(() => {
    const token = sessionStorage.getItem('jwtToken');
    const decoded = jwtDecode(token);

    async function loadConfig() {
      const cfg = await loadTenantConfig(
        decoded.tenantName,
        device?.deviceType
      );

      setConfig(cfg);
    }

    loadConfig();
  }, [device]);
  
  const summarySection = config?.ui?.details?.summarySection;
  const chartSection = config?.ui?.details?.chartSection;

  return (
    <div className="detailboard">
      <h3>Details page for device {deviceId}</h3>
        <div className="detailboard-columns">
          <div className="vert-widget-container">
            {/* Individual Widgets #1 */}
            <div className="widget-box widget-box-1/2">
              <WidgetDeviceSummary
                deviceId={deviceId}
              />
            </div>
            <div className="widget-box widget-box-1/2">
              <DeviceControlPanel
                deviceId={deviceId}
              />
            </div>
          </div>
            <div className="vert-widget-container">
              {/* Summary section */}
              {summarySection?.widgets.map(widget => (
                <div key={widget.id} className="widget-box widget-box-1/5">
                  <WidgetRenderer
                    widget={widget}
                    device={device}
                    deviceId={deviceId}
                    outputs={config?.device?.outputs}
                  />
                </div>
              ))}
            </div>
            {/* Graph section */}
            <div className="vert-widget-container">
              {chartSection?.widgets.map(widget => (
              <div key={widget.id} className="widget-box widget-box-1/2">
                <WidgetRenderer
                  widget={widget}
                  device={device}
                  deviceId={deviceId}
              />
              </div>
              ))}
            </div>
        </div>
    </div>
  );
};

export default DeviceDetailsPage;